import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  
  private apiUrl = environment.BASE_URL;
  api = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': localStorage.getItem("token") ? localStorage.getItem("token") : 'blank',
    })
  };
  private jwtHelper = new JwtHelperService();
  token: any;
  headers: any;

  constructor(private http: HttpClient, private router: Router) {
    this.token = localStorage.getItem('token');
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${this.token}`
    });

  }
  // getSampleData(): Observable<any> {
  //   return this.http.get('assets/indaiData/data.json');
  // }
  register(user: any) {
    return this.http.post(`${this.apiUrl}/register`, user);
  }

  login(credentials: any) {
    return this.http.post(`${this.apiUrl}/login`, credentials).subscribe((res: any) => {
      localStorage.setItem('token', res.token);
      this.router.navigate(['/dashboard']);
    });
  }

  isAuthenticated(): boolean {
    let token = localStorage.getItem('token');
    if (!token) {
      try {
        const user = localStorage.getItem('user');
        if (user) {
          const userParse = JSON.parse(user);
          token = userParse?.token || null;
        }
      } catch {
        // ignore parse errors
      }
    }
    return token ? !this.jwtHelper.isTokenExpired(token) : false;
  }

  logout() {
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }
  registerProject(projectData: any): Observable<any> {

    return this.http.post(`${this.apiUrl}/projects`, projectData, this.headers);
  }

  saveOrganization(params: any) {
    return this.http.post(`${this.api}organizations`, params)
  }
  inviteOrganization(params: any) {
    return this.http.post(`${this.api}organizations/invite`, params);
  }
  completeOrganizationOnboarding() {
    return this.http.post(`${this.api}organizations/complete-onboarding`, {}, this.httpOptions);
  }
  getInvitedOrgStats() {
    return this.http.get(`${this.api}organizations/invite-stats`, this.httpOptions);
  }

  /** Vendor module (supplier accounts + resource uploads) */
  listVendorAccounts() {
    return this.http.get(`${this.api}vendors`, this.httpOptions);
  }
  inviteVendorAccount(body: Record<string, unknown>) {
    return this.http.post(`${this.api}vendors/invite`, body, this.httpOptions);
  }
  createVendorAccount(body: Record<string, unknown>) {
    return this.http.post(`${this.api}vendors`, body, this.httpOptions);
  }
  getVendorAccount(id: number) {
    return this.http.get(`${this.api}vendors/${id}`, this.httpOptions);
  }
  patchVendorAccount(id: number, body: Record<string, unknown>) {
    return this.http.patch(`${this.api}vendors/${id}`, body, this.httpOptions);
  }
  /** Availability only — does not disable vendor login (unlike offboard). */
  suspendVendor(id: number, body?: { reason?: string }) {
    return this.http.post(`${this.api}vendors/${id}/suspend`, body || {}, this.httpOptions);
  }
  unsuspendVendor(id: number) {
    return this.http.post(`${this.api}vendors/${id}/unsuspend`, {}, this.httpOptions);
  }
  getVendorResources(vendorId: number, resourceType?: string) {
    let params = new HttpParams();
    if (resourceType) {
      params = params.set('type', resourceType);
    }
    return this.http.get(`${this.api}vendors/${vendorId}/resources`, { ...this.httpOptions, params });
  }
  createVendorResource(vendorId: number, body: Record<string, unknown>) {
    return this.http.post(`${this.api}vendors/${vendorId}/resources`, body, this.httpOptions);
  }
  deleteVendorResource(vendorId: number, resourceId: number) {
    return this.http.delete(`${this.api}vendors/${vendorId}/resources/${resourceId}`, this.httpOptions);
  }
  saveOrganizationBranch(params: any) {
    return this.http.post(`${this.api}organizations/create-branch`, params)
  }
  getOrganizationsBranch(id: any) {
    return this.http.get(`${this.api}organizations/get-branches/${id}`)
  }
  updateOrganizationBranch(id: any, params: any) {
    return this.http.post(`${this.api}organizations/update-branch/${id}`, params)
  }
  deleteOrganizationBBranch(orgId: number) {
    return this.http.delete(`${this.api}organizations/delete-branch/${orgId}`);
  }
  updateOrganization(id: any, params: any) {
    return this.http.post(`${this.api}organizations/${id}`, params);
  }

  getOrganizations(params: { keyword: string; }) {
    return this.http.get(`${this.api}organizations`)
  }
  deleteOrganization(orgId: number) {
    return this.http.delete(`${this.api}organizations/${orgId}`);
  }
  saveconstructionmaterials(params: any) {
    return this.http.post(`${this.api}construction-materials`, params)
  }
  getconstructionmaterials() {
    return this.http.get(`${this.api}construction-materials`)
  }
  getConstructionMaterialById(id: any) {
    return this.http.get(`${this.api}construction-materials/${id}`)
  }
  updateconstructionmaterials(id: any, params: any) {
    return this.http.put(`${this.api}construction-materials/${id}`, params);
  }
  getStaff(params: { keyword: string; }) {
    return this.http.get(`${this.api}staff`, { params })
  }

  saveStaff(params: any) {
    return this.http.post(`${this.api}staff`, params)
  }
  saveStaffEmp(params: any) {
    return this.http.post(`${this.api}staff/add-employee`, params)
  }

  getStaffById(id: any) {
    return this.http.get(`${this.api}staff/${id}`);
  }

  updateStaff(id: any, params: any) {
    return this.http.post(`${this.api}staff/update/${id}`, params)
  }

  deleteStaff(id: any) {
    return this.http.delete(`${this.api}staff/${id}`)
  }

  offboardStaff(id: any, data?: any) {
    return this.http.post(`${this.api}staff/offboard/${id}`, data || {})
  }

  // Offboarding APIs
  offboardEmployee(id: number, data?: any): Observable<any> {
    return this.http.post(`${this.api}offboarding/employee/${id}`, data || {}, this.httpOptions);
  }

  offboardVendor(id: number, data?: any): Observable<any> {
    return this.http.post(`${this.api}offboarding/vendor/${id}`, data || {}, this.httpOptions);
  }

  offboardMachine(id: number, data?: any): Observable<any> {
    return this.http.post(`${this.api}offboarding/machine/${id}`, data || {}, this.httpOptions);
  }

  offboardConsultant(id: number, data?: any): Observable<any> {
    return this.http.post(`${this.api}offboarding/consultant/${id}`, data || {}, this.httpOptions);
  }

  offboardCompany(id: number, data?: any): Observable<any> {
    return this.http.post(`${this.api}offboarding/company/${id}`, data || {}, this.httpOptions);
  }

  offboardUser(id: number, data?: any): Observable<any> {
    return this.http.post(`${this.api}offboarding/user/${id}`, data || {}, this.httpOptions);
  }

  getOffboardingAuditLog(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}offboarding/audit-log`, { params: httpParams });
  }

  // Reinstate APIs - Reactivate offboarded entities
  reinstateEmployee(id: number, data?: any): Observable<any> {
    return this.http.post(`${this.api}offboarding/reinstate/employee/${id}`, data || {}, this.httpOptions);
  }

  reinstateVendor(id: number, data?: any): Observable<any> {
    return this.http.post(`${this.api}offboarding/reinstate/vendor/${id}`, data || {}, this.httpOptions);
  }

  reinstateMachine(id: number, data?: any): Observable<any> {
    return this.http.post(`${this.api}offboarding/reinstate/machine/${id}`, data || {}, this.httpOptions);
  }

  getClients() {
    return this.http.get(`${this.api}client/`);
  }
  
  getDataByClientId(id:any) {
    return this.http.get(`${this.api}client/${id}`);
  }
  getDashborad() {
    return this.http.get(`${this.api}admin/dashboard`)
  }
  
  getProjectLocations() {
    return this.http.get(`${this.api}admin/project-locations`)
  }
  getlistDesignStages() {
    return this.http.get(`${this.api}project-design-stage`)
  }
    deleteDesignStage(id: any) {
    return this.http.delete(`${this.api}project-design-stage/${id}`, this.headers)
  }
  getDesignStageById(id: any) {
    return this.http.get(`${this.api}project-design-stage/${id}`)
  }
  savelistDesignStages(params: any) {
    return this.http.post(`${this.api}project-design-stage`, params)
  }
  updateDesignStages(id: any, params: any) {
    return this.http.post(`${this.api}project-design-stage/${id}`, params)
  }
    deleteProjectestimation(id: any) {
    return this.http.delete(`${this.api}project-estimation/${id}`, this.headers)
  }
   getProjectestimation() {
    return this.http.get(`${this.api}project-estimation`)
  }
    getProjectestimationId(id:any) {
    return this.http.get(`${this.api}project-estimation/${id}`)
  }
   saveProjectestimation(params: any) {
    return this.http.post(`${this.api}project-estimation`,params)
  }
   updateProjectestimation(id: any,params: any) {
    return this.http.post(`${this.api}project-estimation/${id}`,params)
  }

  // --- Project Survey Stage (lifecycle) ---
  listProjectSurveyStages(params?: { search?: string; status?: string; page?: number; limit?: number; project_id?: string | number }) {
    let httpParams = new HttpParams();
    if (params?.search) httpParams = httpParams.set('search', params.search);
    if (params?.status) httpParams = httpParams.set('status', params.status);
    if (params?.page != null) httpParams = httpParams.set('page', String(params.page));
    if (params?.limit != null) httpParams = httpParams.set('limit', String(params.limit));
    if (params?.project_id != null && params.project_id !== '') {
      httpParams = httpParams.set('project_id', String(params.project_id));
    }
    return this.http.get(`${this.api}project-survey-stage`, { params: httpParams });
  }
  getProjectSurveyStageById(id: number) {
    return this.http.get(`${this.api}project-survey-stage/${id}`);
  }
  saveProjectSurveyStage(params: Record<string, unknown>) {
    return this.http.post(`${this.api}project-survey-stage`, params);
  }
  updateProjectSurveyStage(id: number, params: Record<string, unknown>) {
    return this.http.put(`${this.api}project-survey-stage/${id}`, params);
  }
  deleteProjectSurveyStage(id: number) {
    return this.http.delete(`${this.api}project-survey-stage/${id}`, this.headers);
  }
  processSurveyApproval(id: number, body: { action: string; notes?: string }) {
    return this.http.post(`${this.api}project-survey-stage/${id}/approval`, body, this.httpOptions);
  }

  // --- Project Inspection Stage (lifecycle) ---
  listProjectInspectionStages(params?: { search?: string; status?: string }) {
    let httpParams = new HttpParams();
    if (params?.search) httpParams = httpParams.set('search', params.search);
    if (params?.status) httpParams = httpParams.set('status', params.status);
    return this.http.get(`${this.api}project-inspection-stage`, { params: httpParams });
  }
  getProjectInspectionStageById(id: number) {
    return this.http.get(`${this.api}project-inspection-stage/${id}`);
  }
  saveProjectInspectionStage(params: Record<string, unknown>) {
    return this.http.post(`${this.api}project-inspection-stage`, params);
  }
  updateProjectInspectionStage(id: number, params: Record<string, unknown>) {
    return this.http.post(`${this.api}project-inspection-stage/${id}`, params);
  }
  deleteProjectInspectionStage(id: number) {
    return this.http.delete(`${this.api}project-inspection-stage/${id}`, this.headers);
  }

  // --- Segment inspection workflow ---
  listSegmentInspections(params?: { status?: string; project_id?: number; assigned_to_me?: boolean }) {
    let httpParams = new HttpParams();
    if (params?.status) httpParams = httpParams.set('status', params.status);
    if (params?.project_id) httpParams = httpParams.set('project_id', String(params.project_id));
    if (params?.assigned_to_me) httpParams = httpParams.set('assigned_to_me', 'true');
    return this.http.get(`${this.api}segment-inspections`, { params: httpParams });
  }
  getSegmentInspectionChecklistTemplates() {
    return this.http.get(`${this.api}segment-inspections/checklist-templates`);
  }
  getSegmentInspectionById(id: number) {
    return this.http.get(`${this.api}segment-inspections/${id}`);
  }
  createSegmentInspection(body: Record<string, unknown>) {
    return this.http.post(`${this.api}segment-inspections`, body, this.httpOptions);
  }
  declareSegmentInspectionReady(id: number, body: Record<string, unknown>) {
    return this.http.post(`${this.api}segment-inspections/${id}/declare-ready`, body, this.httpOptions);
  }
  nominateSegmentInspectionEngineer(id: number, body: Record<string, unknown>) {
    return this.http.post(`${this.api}segment-inspections/${id}/nominate-engineer`, body, this.httpOptions);
  }
  completeSegmentInspection(id: number, body: Record<string, unknown>) {
    return this.http.post(`${this.api}segment-inspections/${id}/complete`, body, this.httpOptions);
  }
  deleteSegmentInspection(id: number) {
    return this.http.delete(`${this.api}segment-inspections/${id}`, this.headers);
  }

  // --- Purchase Orders (lifecycle / procurement) ---
  listPurchaseOrders(params?: { search?: string; status?: string }) {
    let httpParams = new HttpParams();
    if (params?.search) httpParams = httpParams.set('search', params.search);
    if (params?.status) httpParams = httpParams.set('status', params.status);
    return this.http.get(`${this.api}purchase-orders`, { params: httpParams });
  }
  getPurchaseOrderById(id: number) {
    return this.http.get(`${this.api}purchase-orders/${id}`);
  }
  savePurchaseOrder(params: Record<string, unknown>) {
    return this.http.post(`${this.api}purchase-orders`, params);
  }
  updatePurchaseOrder(id: number, params: Record<string, unknown>) {
    return this.http.post(`${this.api}purchase-orders/${id}`, params);
  }
  deletePurchaseOrder(id: number) {
    return this.http.delete(`${this.api}purchase-orders/${id}`, this.headers);
  }

    deleteProjectplanning(id: any) {
    return this.http.delete(`${this.api}project-planning/${id}`, this.headers)
  }
  getProjectplanning() {
    return this.http.get(`${this.api}project-planning`)
  }
  getProjectplanningId(id: any) {
    return this.http.get(`${this.api}project-planning/${id}`)
  }
  saveProjectplanning(params: any) {
    return this.http.post(`${this.api}project-planning`, params)
  }
  updateProjectplanning(id: any, params: any) {
    return this.http.post(`${this.api}project-planning/${id}`, params)
  }

  getProjectBidding() {
    return this.http.get(`${this.api}bidding`)
  }
  getProjectBiddingId(id: any) {
    return this.http.get(`${this.api}bidding/bidding/${id}`)
  }
  updateBidStatusToAccepted(id: any, status: string) {
    return this.http.post(`${this.api}bidding/bidding/status/${id}`, { status })
  }
  saveProjectBidding(params: any) {
    return this.http.post(`${this.api}bidding`, params)
  }
  updateProjectBidding(id: any, params: any) {
    return this.http.post(`${this.api}bidding/${id}`, params)
  }
  deleteProjectBidding(id: number) {
    return this.http.delete(`${this.api}bidding/${id}`)
  }
  getProjectM(params: any) {
    return this.http.get(`https://parivesh.nic.in/agendamom/getAgendaMomDocumentByCommitteeV2`, { params })
  }
  getProject(params: any) {
    return this.http.get(`${this.api}project-common`, { params })
  }

  /** Site Receipt Voucher (SRV) / Site Issue Voucher (SIV) — backed by `srv_siv_requests` */
  listSrvSivRequests(
    type: 'SRV' | 'SIV',
    opts?: { search?: string; page?: number; limit?: number; status?: string }
  ) {
    let params = new HttpParams().set('type', type);
    if (opts?.search) {
      params = params.set('search', opts.search);
    }
    if (opts?.page != null) {
      params = params.set('page', String(opts.page));
    }
    if (opts?.limit != null) {
      params = params.set('limit', String(opts.limit));
    }
    if (opts?.status) {
      params = params.set('status', opts.status);
    }
    return this.http.get(`${this.api}srv-siv`, { params });
  }

  createSrvSivRequest(body: {
    type: 'SRV' | 'SIV';
    domain?: string;
    project_common_id?: number | null;
    parent_srv_id?: number | null;
    payload: Record<string, unknown>;
  }) {
    return this.http.post(`${this.api}srv-siv`, body);
  }

  getSrvSivRequest(id: number) {
    return this.http.get(`${this.api}srv-siv/${id}`);
  }

  deleteSrvSivRequest(id: number) {
    return this.http.delete(`${this.api}srv-siv/${id}`);
  }

  getProjectId(id: any) {
    return this.http.get(`${this.api}project-common/${id}`)
  }
  saveProjectCommon(params: any) {
    return this.http.post(`${this.api}project-common`, params)
  }
  updateProjectCommon(id: any, params: any) {
    return this.http.post(`${this.api}project-common/${id}`, params)
  }
  updateProjectStage(id: any, params: any) {
    return this.http.put(`${this.api}project-common/${id}/stage`, params)
  }
  getProjectCommonId(id: any) {
    return this.http.get(`${this.api}project-common/${id}`)
  }

  getProjectHistory(id: number | string, params?: { limit?: number; offset?: number }) {
    let httpParams = new HttpParams();
    if (params?.limit != null) httpParams = httpParams.set('limit', params.limit.toString());
    if (params?.offset != null) httpParams = httpParams.set('offset', params.offset.toString());
    return this.http.get(`${this.api}project-common/${id}/history`, { params: httpParams });
  }

  getProjectVersion(id: number | string, version: number) {
    return this.http.get(`${this.api}project-common/${id}/versions/${version}`);
  }

  restoreProjectVersion(id: number | string, version: number) {
    return this.http.post(`${this.api}project-common/${id}/restore/${version}`, {});
  }

  getProjectCommonAll(params?: any) {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          httpParams = httpParams.set(key, params[key].toString());
        }
      });
    }
    return this.http.get(`${this.api}project-common`, { params: httpParams })
  }

  getProjectStagesSummary() {
    return this.http.get(`${this.api}project-common/stages`);
  }

  // Optimized project search for autocomplete
  searchProjects(params: any) {
    return this.http.get(`${this.api}project-common/search`, { params })
  }

  // Optimized project list for dropdowns
  getProjectListForDropdown(params: any) {
    return this.http.get(`${this.api}project-common/dropdown`, { params })
  }
   deleteProjectCommonId(id: any) {
    return this.http.delete(`${this.api}project-common/${id}`, this.headers)
  }

  // Project staff allocation (add staff with start/end, full or partial)
  getProjectStaffAllocation(projectId: number): Observable<any> {
    return this.http.get(`${this.api}project-common/${projectId}/staff-allocation`, this.httpOptions);
  }
  addProjectStaffAllocation(projectId: number, body: { staff_id: number; start_date: string; end_date: string; allocation_type: 'full' | 'partial'; allocation_percent?: number; remarks?: string }): Observable<any> {
    return this.http.post(`${this.api}project-common/${projectId}/staff-allocation`, body, this.httpOptions);
  }
  updateProjectStaffAllocation(projectId: number, allocationId: number, body: { start_date?: string; end_date?: string; allocation_type?: 'full' | 'partial'; allocation_percent?: number; remarks?: string }): Observable<any> {
    return this.http.patch(`${this.api}project-common/${projectId}/staff-allocation/${allocationId}`, body, this.httpOptions);
  }
  deleteProjectStaffAllocation(projectId: number, allocationId: number): Observable<any> {
    return this.http.delete(`${this.api}project-common/${projectId}/staff-allocation/${allocationId}`, this.httpOptions);
  }
  getStaffAvailability(params: {
    start_date: string;
    end_date: string;
    /** When editing an allocation, exclude this row from used % */
    exclude_allocation_id?: number;
  }): Observable<any> {
    let httpParams = new HttpParams().set('start_date', params.start_date).set('end_date', params.end_date);
    if (params.exclude_allocation_id != null) {
      httpParams = httpParams.set('exclude_allocation_id', params.exclude_allocation_id.toString());
    }
    return this.http.get(`${this.api}project-common/staff-availability`, { ...this.httpOptions, params: httpParams });
  }

  saveProject(params: any) {
    return this.http.post(`${this.api}project`, params)
  }

  updateProject(id: any, params: any) {
    return this.http.post(`${this.api}project/${id}`, params)
  }
  getInvoice() {
    return this.http.get(`${this.api}invoice`,)
  }
  getInvoiceById(id: any) {
    return this.http.get(`${this.api}invoice/${id}`,)
  }

  saveInvoice(params: any) {
    return this.http.post(`${this.api}invoice`, params)
  }
  saveUpdateInvoice(id: any, params: any) {
    return this.http.post(`${this.api}invoice/${id}`, params)
  }
  deleteInvoice(id: any) {
    return this.http.delete(`${this.api}invoice/${id}`)
  }
  updateProjectDoc(id: any, params: any) {
    return this.http.post(`${this.api}project-common/${id}`, params)
  }
  getProjectWork(id: any) {
    return this.http.get(`${this.api}worklog/project-comments/${id}`)
  }
  updateProjectWorkAdd(params: any) {
    return this.http.post(`${this.api}worklog/project-comments/project`, params)
  }
  getProjectById(id: any) {
    return this.http.get(`${this.api}project/${id}`)
  }

  deleteProject(id: any) {
    return this.http.delete(`${this.api}project/${id}`, this.headers)
  }
  getAttendance(params: any, empType: any) {
    console.log(empType)
    return this.http.get(`${this.api}attendance/getall/${empType}`, { params })
  }

  updateAttendance(id: number, params: any, type: string = 'staff'): Observable<any> {
    return this.http.put(`${this.api}attendance/${type}/${id}`, params, this.httpOptions);
  }

  addImport(params: any,) {
    return this.http.post(`${this.api}transactions/import`, params)
  }

  downloadTemplate(type: string): Observable<Blob> {
    const headers = new HttpHeaders({
      'x-access-token': localStorage.getItem("token") ? localStorage.getItem("token") : 'blank',
    });
    return this.http.get(`${this.api}transactions/template/${type}`, {
      headers: headers,
      responseType: 'blob'
    });
  }

  // getAttendance() {
  //   return this.http.get(`${this.api}attendance/getall/1`, this.headers)
  // }

  getMachine(params: { keyword: string; }) {
    return this.http.get(`${this.api}machine`, { params })
  }
  getMachineMaster() {
    return this.http.get(`${this.api}machine-master`)
  }
  listMachineOwners() {
    return this.http.get(`${this.api}machine-owners`, this.httpOptions);
  }
  createMachineOwner(body: Record<string, unknown>) {
    return this.http.post(`${this.api}machine-owners`, body, this.httpOptions);
  }
  updateMachineOwner(id: number, body: Record<string, unknown>) {
    return this.http.patch(`${this.api}machine-owners/${id}`, body, this.httpOptions);
  }
  listCrewMachine(params?: { staff_id?: number | string; machine_id?: number | string; status?: string }) {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as Record<string, unknown>)[key];
        if (value !== null && value !== undefined && value !== '') {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }
    return this.http.get(`${this.api}crew-machine`, { ...this.httpOptions, params: httpParams });
  }
  assignCrewMachine(body: Record<string, unknown>) {
    return this.http.post(`${this.api}crew-machine`, body, this.httpOptions);
  }
  updateCrewMachine(id: number, body: Record<string, unknown>) {
    return this.http.put(`${this.api}crew-machine/${id}`, body, this.httpOptions);
  }
  deleteCrewMachine(id: number) {
    return this.http.delete(`${this.api}crew-machine/${id}`, this.httpOptions);
  }
  getMachineMasterId(id: any) {
    return this.http.get(`${this.api}machine-master/${id}`)
  }
  saveMachineMaster(params: any) {
    return this.http.post(`${this.api}machine-master`, params)
  }

  updateMachineMaster(id: any, params: any) {
    return this.http.post(`${this.api}machine-master/${id}`, params)
  }

  // Machine reservations
  getMachineReservations(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          httpParams = httpParams.set(key, params[key].toString());
        }
      });
    }
    return this.http.get(`${this.api}machine-reservations`, { params: httpParams });
  }
  getMachineReservationCalendar(params: { from_date: string; to_date: string; machine_id?: number | string; project_id?: number | string }): Observable<any> {
    let httpParams = new HttpParams()
      .set('from_date', params.from_date)
      .set('to_date', params.to_date);
    if (params.machine_id) httpParams = httpParams.set('machine_id', params.machine_id.toString());
    if (params.project_id) httpParams = httpParams.set('project_id', params.project_id.toString());
    return this.http.get(`${this.api}machine-reservations/calendar`, { params: httpParams });
  }
  checkMachineAvailability(params: {
    machine_id: number | string;
    start_date: string;
    end_date: string;
    exclude_id?: number;
  }): Observable<any> {
    let httpParams = new HttpParams()
      .set('machine_id', params.machine_id.toString())
      .set('start_date', params.start_date)
      .set('end_date', params.end_date);
    if (params.exclude_id != null) {
      httpParams = httpParams.set('exclude_id', params.exclude_id.toString());
    }
    return this.http.get(`${this.api}machine-reservations/check-availability`, { params: httpParams });
  }
  getMachineReservationById(id: number): Observable<any> {
    return this.http.get(`${this.api}machine-reservations/${id}`);
  }
  createMachineReservation(data: any): Observable<any> {
    return this.http.post(`${this.api}machine-reservations`, data, this.httpOptions);
  }
  updateMachineReservation(id: number, data: any): Observable<any> {
    return this.http.put(`${this.api}machine-reservations/${id}`, data, this.httpOptions);
  }
  cancelMachineReservation(id: number, data?: any): Observable<any> {
    return this.http.patch(`${this.api}machine-reservations/${id}/cancel`, data || {}, this.httpOptions);
  }

  getVendorRankingDashboard(params?: { project_id?: number | string; limit?: number }): Observable<any> {
    let httpParams = new HttpParams();
    if (params?.project_id) httpParams = httpParams.set('project_id', params.project_id.toString());
    if (params?.limit) httpParams = httpParams.set('limit', params.limit.toString());
    return this.http.get(`${this.api}vendor-ranking/dashboard`, { params: httpParams });
  }
  getVendorRankingInvitations(params?: { project_id?: number | string }): Observable<any> {
    let httpParams = new HttpParams();
    if (params?.project_id) httpParams = httpParams.set('project_id', params.project_id.toString());
    return this.http.get(`${this.api}vendor-ranking/invitations`, { params: httpParams });
  }
  getVendorRankingByInvitation(invitationId: number | string): Observable<any> {
    return this.http.get(`${this.api}vendor-ranking/invitation/${invitationId}`);
  }
  previewGisBoq(data: any): Observable<any> {
    return this.http.post(`${this.api}gis-boq/preview`, data, this.httpOptions);
  }
  applyGisBoq(data: any): Observable<any> {
    return this.http.post(`${this.api}gis-boq/apply`, data, this.httpOptions);
  }

  getGisBoqRateCard(): Observable<any> {
    return this.http.get(`${this.api}gis-boq/rate-card`, this.httpOptions);
  }

  saveGisBoqRateCard(data: {
    pavement?: any[];
    assets?: Record<string, any>;
    shoulder?: any;
    median?: any;
  }): Observable<any> {
    return this.http.put(`${this.api}gis-boq/rate-card`, data, this.httpOptions);
  }
  resolveGisBoqLength(params: { project_id?: number; route_id?: number; from_km?: number; to_km?: number }): Observable<any> {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v != null) httpParams = httpParams.set(k, String(v));
    });
    return this.http.get(`${this.api}gis-boq/resolve-length`, { params: httpParams });
  }
  getBoqItemsAtChainage(params: {
    project_id?: number | string;
    route_id?: number | string;
    km?: number | string;
    from_km?: number | string;
    to_km?: number | string;
  }): Observable<any> {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v != null && v !== '') httpParams = httpParams.set(k, String(v));
    });
    return this.http.get(`${this.api}gis-boq/items-at-chainage`, { ...this.httpOptions, params: httpParams });
  }

  getMaterialsMaster() {
    return this.http.get(`${this.api}materials-master`)
  }

  saveMachine(params: any) {
    return this.http.post(`${this.api}machine`, params)
  }


  // login (params: any) {
  //   return this.http.post(`${this.api}user/login`,params);
  // }
  getUserMenu(params: any) {
    return this.http.post(`${this.api}user/userMenu`, params);
  }

  getBreakingContent(id: any) {
    return this.http.get(`${this.api}category/getAdminCategory`);
  }
  getNewsScroll() {
    return this.http.get(`${this.api}story/getNewsScroll`);
  }
  getAllNewsScroll() {
    return this.http.get(`${this.api}story/getAllNewsScroll`);
  }

  addNewsScroll(params: any) {
    return this.http.post(`${this.api}story/addNewsScroll`, params);
  }

  editNewsScroll(params: any) {
    return this.http.post(`${this.api}story/editNewsScroll`, params);
  }

  deleteNewsScroll(params: any) {
    return this.http.post(`${this.api}story/deleteNewsScroll`, params);
  }

  updateContent(one: any, two: any) {
    return this.http.get(`${this.api}category/getAdminCategory`);
  }

  updateImage(one: any, two: any) {
    return this.http.get(`${this.api}category/getAdminCategory`);
  }
  updateStoryPriority(params: any) {
    return this.http.post(`${this.api}story/updatePriority`, params);
  }

  updateVideoPriority(params: any) {
    return this.http.post(`${this.api}story/updateVideoPriority`, params);
  }

  updatePhotoPriority(params: any) {
    return this.http.post(`${this.api}story/updatePhotoPriority`, params);
  }
  getCategories() {
    return this.http.get(`${this.api}category/getCategory`);
  }
  getAdminCategories() {
    return this.http.get(`${this.api}category/getAdminCategory`);
  }

  getSubCategory() {
    return this.http.get(`${this.api}category/getSubCategory`);
  }

  getCategoriesKeywords() {
    return this.http.get(`${this.api}category/getAdminCategoryKeywords`);
  }

  addCategory(params: any) {
    return this.http.post(`${this.api}category/addCategory`, params);
  }

  editCategory(params: any) {
    return this.http.post(`${this.api}category/editCategory`, params);
  }

  getSubCategories() {
    return this.http.get(`${this.api}category/getSubCategory`);
  }

  addSubCategory(params: any) {
    return this.http.post(`${this.api}category/addSubCategory`, params);
  }

  editSubCategory(params: any) {
    return this.http.post(`${this.api}category/editSubCategory`, params);
  }

  getLanguages() { return this.http.get(`${this.api}language/language`); }

  addLanguage(params: any) {
    return this.http.post(`${this.api}language/addLanguage`, params);
  }

  editLanguage(params: any) {
    return this.http.post(`${this.api}language/editLanguage`, params);
  }

  getBlogs() { return this.http.get(`${this.api}blog/blog`); }

  addBlog(params: any) {
    return this.http.post(`${this.api}blog/addBlog`, params);
  }

  editBlog(params: any) {
    return this.http.post(`${this.api}blog/editBlog`, params);
  }

  getBlogDetails(storyID: any) {
    return this.http.get(`${this.api}blog/blog_details/${storyID}`);
  }

  getAuthors() { return this.http.get(`${this.api}author/authors`); }

  getStates() { return this.http.get(`${this.api}state/states`); }
  getJobKeywords() { return this.http.get(`${this.api}job/getJobKeywords`); }
  addJobKeyword(params: any) {
    return this.http.post(`${this.api}job/addJobKeyword`, params);
  }

  editJobKeyword(params: any) {
    return this.http.post(`${this.api}job/editJobKeyword`, params);
  }
  addState(params: any) {
    return this.http.post(`${this.api}state/addState`, params);
  }

  editState(params: any) {
    return this.http.post(`${this.api}state/editState`, params);
  }

  getCities(stateID: any) { return this.http.get(`${this.api}city/cities/${stateID}`); }

  addCity(params: any) {
    return this.http.post(`${this.api}city/addCity`, params);
  }

  editCity(params: any) {
    return this.http.post(`${this.api}city/editCity`, params);
  }

  getAdminStories() {
    return this.http.get(`${this.api}story/adminStory`);
  }

  getUsers(params: any) {
    return this.http.get(`${this.api}users`, params);
  }


  searchPrimeVideos(params: any) {
    return this.http.post(`${this.api}story/searchPrimeVideos`, params);
  }

  searchPrimeImages(params: any) {
    return this.http.post(`${this.api}story/searchPrimeImages`, params);
  }


  searchBreakingNews(params: any) {
    return this.http.post(`${this.api}story/searchBreakingNews`, params);
  }
  getDraftStories() {
    return this.http.get(`${this.api}story/draft`);
  }

  searchStory(params: any) {
    return this.http.post(`${this.api}story/searchStory`, params);
  }
  searchDraftStory(params: any) {
    return this.http.post(`${this.api}story/searchDraftStory`, params);
  }

  editStory(params: any) {
    return this.http.post(`${this.api}story/editStory`, params);
  }

  updateStoryStatus(params: any) {
    return this.http.post(`${this.api}story/updateStatus`, params);
  }

  deleteStoryCategory(params: any) {
    return this.http.post(`${this.api}story/deleteStoryCategory`, params);
  }
  deleteSubCategory(params: any) {
    return this.http.post(`${this.api}story/deleteSubCategory`, params);
  }

  addStory(params: any) {
    return this.http.post(`${this.api}story/addStory`, params);
  }

  getVideos() {
    return this.http.get(`${this.api}video/video`);
  }
  addVideo(params: any) {
    return this.http.post(`${this.api}video/addVideo`, params);
  }
  editVideo(params: any) {
    return this.http.post(`${this.api}video/editVideo`, params);
  }


  getVideoCategory() {
    return this.http.get(`${this.api}video/videoCategory`);

  }


  getVideoDetails(id: any) {
    return this.http.get(`${this.api}video/video_details_edit/${id}`);
  }

  getTopFour() {
    return this.http.get(`${this.api}story/getFeaturedPostAll`);
  }

  getGalleryPost() {
    return this.http.get(`${this.api}story/getGalleryPost`);
  }

  getGallery() {
    return this.http.get(`${this.api}story/getGallery`);
  }

  getGalleryCategory() {
    return this.http.get(`${this.api}story/getGalleryCategory`);
  }

  getGalleryCount() {
    return this.http.get(`${this.api}story/getGalleryCount`);
  }

  addGalleryCategory(params: any) {
    return this.http.post(`${this.api}category/addGalleryCategory`, params);
  }

  getGalleryByID(id: any) {
    console.log(id);
    return this.http.get(`${this.api}story/get_gallery_post_details/` + id);
  }

  deleteGalleryImage(params: any) {
    return this.http.post(`${this.api}story/deleteImage/`, params);
  }

  editGalleryCategory(params: any) {
    return this.http.post(`${this.api}category/editGalleryCategory`, params);
  }
  addGalleryPost(params: any) {
    return this.http.post(`${this.api}story/addGalleryPost`, params);
  }

  editGalleryPost(params: any) {
    return this.http.post(`${this.api}story/editGalleryPost`, params);
  }
  updateGalleryStatus(params: any) {
    return this.http.post(`${this.api}category/updateGalleryStatus`, params);
  }
  saveCategoryKeywords(params: any) {
    return this.http.post(`${this.api}category/saveCategoryKeywords`, params);
  }

  getUser() {
    return this.http.get(`${this.api}author/users`);
  }
  saveUser(params: any) {
    return this.http.post(`${this.api}author/saveUser`, params);
  }

  addUser(params: any) {
    return this.http.post(`${this.api}users/createUser`, params);
  }

  /** Subscription seat-budget preview for the current org/branch. */
  getSeatBudget() {
    return this.http.get(`${this.api}subscription/seat-budget`);
  }

  updateUser(id: any, params: any) {
    return this.http.post(`${this.api}users/update/${id}`, params);
  }

  updateUserWithLogo(id: any, formData: FormData) {
    return this.http.post(`${this.api}users/update/${id}`, formData);
  }

  getUserById(params: any) {
    return this.http.post(`${this.api}users/${params}`, {});
  }

  deleteUserById(params: any) {
    return this.http.delete(`${this.api}users/${params}`, {});
  }

  getAuthor() {
    return this.http.get(`${this.api}author/getAuthor`);
  }

  saveAuthor(params: any) {
    return this.http.post(`${this.api}author/saveAuthor`, params);
  }

  getUsergroup() {
    return this.http.get(`${this.api}admin/usergroup`);
  }
  getMasterUsers() {
    return this.http.get(`${this.api}admin/users`);
  }


  getDashboardData() {
    return this.http.get(`${this.api}admin/dashboardData`);
  }

  getTopNewsData() {
    return this.http.get(`${this.api}admin/getTopNewsData`);
  }

  updateUserGroupType(params: any) {
    return this.http.post(`${this.api}admin/updateUserGroupType`, params);
  }

  getClassified() {
    return this.http.get(`${this.api}classified/classified`);
  }
  getAdminClassified() {
    return this.http.get(`${this.api}classified/adminClassified`);
  }

  addClassified(params: any) {
    return this.http.post(`${this.api}classified/addClassified`, params);
  }

  editClassified(params: any) {
    return this.http.post(`${this.api}classified/editClassified`, params);
  }

  getClassifiedCategory() {
    return this.http.get(`${this.api}classified/classifiedCategory`);
  }
  addClassifiedCategory(params: any) {
    return this.http.post(`${this.api}classified/addClassifiedCategory`, params);
  }

  editClassifiedCategory(params: any) {
    return this.http.post(`${this.api}classified/editClassifiedCategory`, params);
  }
  getClassifiedSubCategory() {
    return this.http.get(`${this.api}classified/classifiedSubCategory`);
  }
  addClassifiedSubCategory(params: any) {
    return this.http.post(`${this.api}classified/addClassifiedSubCategory`, params);
  }
  editClassifiedSubCategory(params: any) {
    return this.http.post(`${this.api}classified/editClassifiedSubCategory`, params);
  }


  getClassifiedSubSubCategory() {
    return this.http.get(`${this.api}classified/classifiedSubSubCategory`);
  }
  addClassifiedSubSubCategory(params: any) {
    return this.http.post(`${this.api}classified/addClassifiedSubSubCategory`, params);
  }

  editClassifiedSubSubCategory(params: any) {
    return this.http.post(`${this.api}classified/editClassifiedSubSubCategory`, params);
  }

  getPublicClassified() {
    return this.http.get(`${this.api}classified/publicClassified`);
  }
  addPublicClassified(params: any) {
    return this.http.post(`${this.api}classified/addPublicClassified`, params);
  }
  editPublicClassified(params: any) {
    return this.http.post(`${this.api}classified/editPublicClassified`, params);
  }



  getQuizCategory() {
    return this.http.get(`${this.api}quiz/quizCategory`);
  }
  addQuizCategory(params: any) {
    return this.http.post(`${this.api}quiz/addQuizCategory`, params);
  }
  editQuizCategory(params: any) {
    return this.http.post(`${this.api}quiz/editQuizCategory`, params);
  }

  getAdminJobs(page_number: any) {
    return this.http.get(`${this.api}job/getAdminJobs/`);
  }

  getJobs() {
    return this.http.get(`${this.api}job/getJobs`);
  }
  addJob(params: any) {
    return this.http.post(`${this.api}job/addJob`, params);
  }

  editJob(params: any) {
    return this.http.post(`${this.api}job/editJob`, params);
  }

  changePassword(params: any) {
    return this.http.post(`${this.api}users/changePassword`, params);
  }
  // editCategory(params: any) {
  //   return this.http.post(`${this.api}category/editCategory`, params);
  // }


  saveResult(params: any) {
    return this.http.post(`${this.api}poll/saveResult`, params);
  }
  getResult(params: any) {
    return this.http.post(`${this.api}poll/getAllResult`, params);
  }


  getSubjects() {
    return this.http.get(`http://quizmaster.egensoftwares.com/get_all_subject.php?user_id=1&role=AMIN`);

  }

  // Returns an observable
  upload(file: any): Observable<any> {

    // Create form data
    const formData = new FormData();

    // Store form name as "file" with file data
    formData.append("file", file, file.name);

    // Make http post request over api
    // with formData as req
    return this.http.post(`${this.api}category/uploadFile`, formData)
  }
  // Returns an observable
  uploadImage(file: any): Observable<any> {

    // Create form data
    const formData = new FormData();

    // Store form name as "file" with file data
    formData.append("file", file, file.name);

    // Make http post request over api
    // with formData as req
    return this.http.post(`${this.api}category/editorImage`, formData)
  }

  sendNotification(params: any) {
    const headers = new HttpHeaders({
      'Authorization': `api_key=16876039d454076de15b6a6681ad2e16`,
      'Content-Type': 'application/json',
    });
    // const headers = new HttpHeaders().set('Authorization', `api_key=16876039d454076de15b6a6681ad2e16`);
    // return this.http.post(`https://begumganjbazaar.egensoftwares.com/notifier.php`, params);
    // return this.http.post(`https://api.pushalert.co/rest/v1/send`, params,{headers});
    return this.http.post(`${this.api}admin/sendNotification`, params);
  }
  //create package details
  subscribePackage(params: any) {
    return this.http.post(this.api + 'packagedetail/', params, this.httpOptions);

  }
  createPackageDetail(packageDetail: any): Observable<any> {
    return this.http.post(this.api + 'packagedetail/save', packageDetail, this.httpOptions);
  }
  getAllPackage(): Observable<any> {
    return this.http.get(this.api + 'package/getall', this.httpOptions);
  }
  updatePackageById(id: any, data: any): Observable<any> {

    return this.http.post(`${this.api + 'package/update'}/${id}`, data, this.httpOptions);
  }
  deletePackageById(id: any): Observable<any> {
    return this.http.delete(`${this.api + 'package/delete'}/${id}`, this.httpOptions);
  }

  //
  getAllTransition(): Observable<any> {
    return this.http.get(this.api + 'transaction/getall', this.httpOptions);
  }
  getAllPayment(): Observable<any> {
    return this.http.get(this.api + 'transaction/getallPayment', this.httpOptions);
  }
  getAllDashBoardRecord(): Observable<any> {
    return this.http.get(this.api + 'user/allRecord', this.httpOptions);
  }

  saveUpdatedUserPlan(data: any): Observable<any> {
    return this.http.post(this.api + 'website/saveUdatedUserPlan', data);
  }

  deleteUserTransaction(id: any): Observable<any> {
    return this.http.delete(`${this.api + 'website/deleteTransaction'}/${id}`, this.httpOptions);
  }

  getUserPackageList(): Observable<any> {
    return this.http.get(this.api + 'website/userWisePackageSiteDetail', this.httpOptions);
  }
  deleteUserPlan(id: any): Observable<any> {
    return this.http.delete(`${this.api} + 'auth/delete'}/${id}`, this.httpOptions);
  }
  updatePackageDetail(id: any, data: any): Observable<any> {

    return this.http.post(`${this.api + 'packagedetail/update'}/${id}`, data, this.httpOptions);
  }
  deletePackageDetail(id: any): Observable<any> {
    return this.http.delete(`${this.api + 'packagedetail/delete'}/${id}`, this.httpOptions);
  }

  getAllPackageDetail(): Observable<any> {
    return this.http.get(this.api + 'packagedetail/getall', this.httpOptions);
  }
  getPackageById(id: any): Observable<any> {
    return this.http.get(`${this.api + 'packagedetail/getPackgeById'}/${id}`, this.httpOptions);
  }
  //package Type
  createPackageType(packagetype: any): Observable<any> {
    return this.http.post(this.api + 'packagetype/save', {
      name: packagetype.name,
      status: packagetype.status,

    }, this.httpOptions);
  }


  updatePackageType(id: any, data: any): Observable<any> {

    return this.http.post(`${this.api + 'packagetype/update'}/${id}`, data, this.httpOptions);
  }
  deletePackageType(id: any): Observable<any> {
    return this.http.delete(`${this.api + 'packagetype/delete'}/${id}`, this.httpOptions);
  }

  getAllPackageType(): Observable<any> {
    return this.http.get(this.api + 'packagetype/getall', this.httpOptions);
  }


  //email Templates 
  createEmailTemplate(email: any) {
    return this.http.post(this.api + 'email/save', {
      tblAdminId: email.tblAdminId,
      constant: email.constant,
      type: email.type,
      subject: email.subject,
      description: email.description,
      template: email.template,
      emailStatus: email.emailStatus
    }, this.httpOptions);
  }
  updateEmailTemplate(id: any, data: any): Observable<any> {
    return this.http.post(`${this.api + 'email/update'}/${id}`, data, this.httpOptions);
  }
  deleteEmailTemplate(id: any): Observable<any> {
    return this.http.delete(`${this.api + 'email/delete'}/${id}`, this.httpOptions);
  }
  getAllEmailTemplate(): Observable<any> {
    return this.http.get(this.api + 'email/getall', this.httpOptions);
  }
  getByIdEmailTemplate(id: any): Observable<any> {
    return this.http.get(this.api + 'email/getById/' + id, this.httpOptions);
  }

  getAllRoles(): Observable<any> {
    return this.http.get(this.api + 'roles', this.httpOptions);
  }
  saveRole(params: any) {
    return this.http.post(`${this.api}roles`, params)
  }
  updateRole(id: any, params: any) {
    return this.http.post(`${this.api}roles/update/${id}`, params)
  }
  deleteRole(id: number) {
    return this.http.delete(`${this.api}roles/${id}`);
  }
  getRoleById(id: any) {
    return this.http.post(`${this.api}roles/${id}`, {});
  }


  uploadContractDocs(event: any, type: string) {
    const file = event
    if (!file) {
      console.error('No file selected for upload');

    }

    const uploadMap: { [key: string]: string } = {
      docs: 'docs',
      dpr: 'dpr',
      drawings: 'drawings',
      reports: 'reports',
      qap: 'qap',
      testReports: 'testReports',
      asBuiltDrawings: 'asBuiltDrawings',
      Manuals: 'Manuals',
      org: 'org',
    };

    const endpoint = uploadMap[type];
    if (!endpoint) {
      console.error('Invalid upload type');

    }

    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(
      `${this.api}users/upload/${endpoint}`,
      formData,
      // {
      //   headers: {
      //     Authorization: `Bearer ${this.token}`,
      //      //  only auth header, no Content-Type
      //   },
      //   responseType: 'text' as 'json'
      // }
    );
  }

  getOrganizationById(id: string): Observable<any> {
    return this.http.post(`${this.api + 'organization/update'}/${id}`, id, this.httpOptions);
  }


  createPackage(data: any) {
    return this.http.post(this.api + 'packages', data, this.httpOptions);
  }

  updatePackage(id: number, data: any) {
    return this.http.put(this.api + `packages/${id}`, data, this.httpOptions);
  }

  getPackageDetailsById(id: number) {
    return this.http.get<any>(this.api + `packages/${id}`, this.httpOptions);
  }

  deletePackage(id: number) {
    return this.http.delete<any>(this.api + `packages/${id}`, this.httpOptions);
  }

  getAllPackageDetails(): Observable<any> {
    return this.http.get<any>(this.api + `packages`, this.httpOptions);
  }

  createSubscription(data: any) {
    return this.http.post<any>(this.api + `subscription/create-subscription`, data, this.httpOptions);
  }
  
  getSubscriptionDetails(data: any) {
    return this.http.post<any>(this.api + `subscription/get-subscription`, data, this.httpOptions);
  }

  getSubscriptionByPaymentId(paymentId: string): Observable<any> {
    return this.http.get<any>(this.api + `subscription/subscription-by-payment/${paymentId}`, this.httpOptions);
  }

  getActivePackages(): Observable<any> {
    return this.http.get<any>(this.api + `packages`, this.httpOptions);
  }
  subscribeToPackage(data: any) {
    return this.http.post<any>(this.api + `payment/stripe`, data, this.httpOptions);
  }
  createOrderRazorPay(amount: number) {
    return this.http.post<any>('payment/razerpay', { amount });
  }

  // Razorpay subscription methods
  createSubscriptionRazorpayOrder(data: any): Observable<any> {
    return this.http.post<any>(this.api + `payment/subscription/razorpay/order`, data, this.httpOptions);
  }

  verifySubscriptionRazorpayPayment(subscriptionId: number, paymentData: any): Observable<any> {
    return this.http.post<any>(
      `${this.api}payment/subscription/${subscriptionId}/razorpay/verify`,
      paymentData,
      this.httpOptions
    );
  }

  // Subscription Management APIs
  renewSubscription(subscriptionId: number, renewalData: any): Observable<any> {
    return this.http.post(`${this.api}subscription/subscriptions/${subscriptionId}/renew`, renewalData, this.httpOptions);
  }

  suspendSubscription(subscriptionId: number, reason?: string): Observable<any> {
    return this.http.post(`${this.api}subscription/subscriptions/${subscriptionId}/suspend`, { reason }, this.httpOptions);
  }

  reactivateSubscription(subscriptionId: number, reason?: string): Observable<any> {
    return this.http.post(`${this.api}subscription/subscriptions/${subscriptionId}/reactivate`, { reason }, this.httpOptions);
  }

  downgradeSubscription(subscriptionId: number, downgradeData: any): Observable<any> {
    return this.http.post(`${this.api}subscription/subscriptions/${subscriptionId}/downgrade`, downgradeData, this.httpOptions);
  }

  updateAutoRenewal(subscriptionId: number, autoRenewData: any): Observable<any> {
    return this.http.put(`${this.api}subscription/subscriptions/${subscriptionId}/auto-renewal`, autoRenewData, this.httpOptions);
  }

  getSubscriptionAuditLog(subscriptionId: number, params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}subscription/subscriptions/${subscriptionId}/audit-log`, { params: httpParams });
  }

  // Upgrade subscription methods
  calculateUpgradeCost(subscriptionId: number, upgradeData: any): Observable<any> {
    return this.http.post<any>(
      `${this.api}subscription/subscriptions/${subscriptionId}/upgrade/calculate`,
      upgradeData,
      this.httpOptions
    );
  }

  processUpgradePayment(subscriptionId: number, paymentData: any): Observable<any> {
    return this.http.post<any>(
      `${this.api}subscription/subscriptions/${subscriptionId}/upgrade/process`,
      paymentData,
      this.httpOptions
    );
  }
  savePaymentDetails(data: any) {
    return this.http.post<any>(this.api + `payment/save`, data, this.httpOptions);
  }
  getAllTransactionsList(): Observable<any> {
    return this.http.get<any>(this.api + `transactions/getall`, this.httpOptions);
  }

  getSubscriptionsList(id:any): Observable<any> {
    return this.http.get<any>(this.api + `subscription/organization/${id}/subscriptions`, this.httpOptions);
  }

  /**
   * Super Admin only: PATCH-style update of a subscription row.
   * The backend accepts any subset of fields (users_count, consultancy_projects,
   * duration, total_amount, membership_start_date, membership_end_date,
   * status, payment_status, subscription_user_type, road/construction/utilities/consultancy).
   */
  updateSubscription(id: number | string, data: any): Observable<any> {
    return this.http.put<any>(`${this.api}subscription/subscriptions/${id}`, data, this.httpOptions);
  }
  getstates() {
    return this.http.get(`${this.api}location/states`,)
  }
  getdistricts(param: any) {
    return this.http.get(`${this.api}location/districts?state=` + encodeURIComponent(param))
  }
  getSubdistricts(param: any, param1: any) {
    return this.http.get(
      `${this.api}location/subDistricts?state=` + encodeURIComponent(param) + '&district=' + encodeURIComponent(param1)
    )
  }
  getvillages(param: any, param1: any, param2: any) {
    return this.http.get(`${this.api}location/villages?state=` + param + '&district=' + param1 + '&subDistrict=' + param2)
  }

  //bom

  // Get all BoMs
  getBoms(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }
    return this.http.get(`${this.api}/boms`, { params: httpParams });
  }

  // Get single BOM
  getBom(id: number): Observable<any> {
    return this.http.get(`${this.api}/boms/${id}`);
  }

  // Create BOM
  createBom(data: any): Observable<any> {
    return this.http.post(`${this.api}/boms`, data);
  }

  // Update BOM
  updateBom(id: number, data: any): Observable<any> {
    return this.http.put(`${this.api}/boms/${id}`, data);
  }

  // Delete BOM
  deleteBom(id: number): Observable<any> {
    return this.http.delete(`${this.api}/boms/${id}`);
  }

  // BOM Approvals
  approveBom(id: number, data: any): Observable<any> {
    return this.http.post(`${this.api}/boms/${id}/approve`, data);
  }

  getBomApprovals(id: number): Observable<any> {
    return this.http.get(`${this.api}/boms/${id}/approvals`);
  }

  // BOM Export
  exportBom(id: number, format: string = 'json'): Observable<any> {
    return this.http.get(`${this.api}/boms/${id}/export?format=${format}`, { responseType: 'blob' });
  }

  // ==================== MATERIALS ====================

  getMaterials(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }
    return this.http.get(`${this.api}/bom/materials`, { params: httpParams });
  }

  createMaterial(data: any): Observable<any> {
    return this.http.post(`${this.api}/bom/materials`, data);
  }

  updateMaterial(id: number, data: any): Observable<any> {
    return this.http.put(`${this.api}/bom/materials/${id}`, data);
  }

  // ==================== MATERIAL CATEGORIES ====================

  getMaterialCategories(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }
    return this.http.get(`${this.api}/bom/categories`, { params: httpParams });
  }

  createMaterialCategory(data: any): Observable<any> {
    return this.http.post(`${this.api}/bom/categories`, data);
  }

  // ==================== BOM TEMPLATES ====================

  getBomTemplates(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }
    return this.http.get(`${this.api}/bom/templates`, { params: httpParams });
  }

  getBomTemplate(id: number): Observable<any> {
    return this.http.get(`${this.api}/bom/templates/${id}`);
  }

  createBomTemplate(data: any): Observable<any> {
    return this.http.post(`${this.api}/bom/templates`, data);
  }

  // ==================== PROJECTS ====================

  getProjects(): Observable<any> {
    return this.http.get(`${this.api}project-c`);
  }

  // Get single BoM
  getBomById(id: number): Observable<any> {
    return this.http.get<any>(`${this.api}boms/${id}`);
  }

  // ==================== GIS API METHODS ====================

  // Layer Management
  getGisLayers(): Observable<any> {
    return this.http.get(`${this.api}gis/layers`);
  }

  createGisLayer(layerData: any): Observable<any> {
    return this.http.post(`${this.api}gis/layers`, layerData);
  }

  deleteGisLayer(layerName: string): Observable<any> {
    return this.http.delete(`${this.api}gis/layers/${layerName}`);
  }

  getLayerMetadata(layerName: string): Observable<any> {
    return this.http.get(`${this.api}gis/layers/${layerName}/metadata`);
  }

  createSpatialIndex(layerName: string): Observable<any> {
    return this.http.post(`${this.api}gis/layers/${layerName}/index`, {});
  }

  duplicateGisLayer(layerName: string, newLayerName: string): Observable<any> {
    return this.http.post(`${this.api}gis/layers/${layerName}/duplicate`, { newLayerName });
  }

  // Feature Management
  getGisFeatures(layerName: string, params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }
    return this.http.get(`${this.api}gis/layers/${layerName}/features`, { params: httpParams });
  }

  createGisFeature(layerName: string, featureData: any): Observable<any> {
    return this.http.post(`${this.api}gis/layers/${layerName}/features`, featureData);
  }

  updateGisFeature(layerName: string, featureId: number, featureData: any): Observable<any> {
    return this.http.put(`${this.api}gis/layers/${layerName}/features/${featureId}`, featureData);
  }

  deleteGisFeature(layerName: string, featureId: number): Observable<any> {
    return this.http.delete(`${this.api}gis/layers/${layerName}/features/${featureId}`);
  }

  batchUpdateGisFeatures(layerName: string, updates: any[]): Observable<any> {
    return this.http.put(`${this.api}gis/layers/${layerName}/batch-update`, { updates });
  }

  // Import/Export
  importGisGeoJSON(layerName: string, geoJsonData: any): Observable<any> {
    return this.http.post(`${this.api}gis/layers/${layerName}/import`, geoJsonData);
  }

  exportGisGeoJSON(layerName: string, params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }
    return this.http.get(`${this.api}gis/layers/${layerName}/export`, { params: httpParams });
  }

  exportGisToFormat(layerName: string, format: string, params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }
    return this.http.get(`${this.api}gis/layers/${layerName}/export/${format}`, { params: httpParams });
  }

  // Spatial Analysis
  performSpatialQuery(queryData: any): Observable<any> {
    return this.http.post(`${this.api}gis/spatial-query`, queryData);
  }

  bufferAnalysis(analysisData: any): Observable<any> {
    return this.http.post(`${this.api}gis/analysis/buffer`, analysisData);
  }

  intersectionAnalysis(analysisData: any): Observable<any> {
    return this.http.post(`${this.api}gis/analysis/intersection`, analysisData);
  }

  // Layer Statistics
  getLayerStats(layerName: string): Observable<any> {
    return this.http.get(`${this.api}gis/layers/${layerName}/stats`);
  }

  // Geometry Validation and Repair
  validateGeometry(layerName: string): Observable<any> {
    return this.http.get(`${this.api}gis/layers/${layerName}/validate`);
  }

  repairGeometry(layerName: string): Observable<any> {
    return this.http.post(`${this.api}gis/layers/${layerName}/repair`, {});
  }

  // Shapefile Import
  importShapefile(layerName: string, filePath: string, srid?: number): Observable<any> {
    return this.http.post(`${this.api}gis/import/shapefile`, { layerName, filePath, srid });
  }

  // Project-specific GIS operations
  saveProjectGisData(projectId: string, layerName: string, gisData: any): Observable<any> {
    return this.http.post(`${this.api}project/${projectId}/gis/layers/${layerName}/save`, gisData);
  }

  loadProjectGisData(projectId: string, layerName: string): Observable<any> {
    return this.http.get(`${this.api}project/${projectId}/gis/layers/${layerName}`);
  }

  // Auto-save functionality
  autoSaveGisData(projectId: string, layerName: string, gisData: any): Observable<any> {
    return this.http.post(`${this.api}project/${projectId}/gis/layers/${layerName}/auto-save`, gisData);
  }

  // Get project GIS summary
  getProjectGisSummary(projectId: string): Observable<any> {
    return this.http.get(`${this.api}project/${projectId}/gis/summary`);
  }

  /** Push GIS-derived metrics (length, width, area) to project/ERP record */
  pushGisMetricsToProject(projectId: string, metrics: { road_length?: number; lane_width_adjustment?: number; lane_configuration?: number; size?: number }): Observable<any> {
    return this.http.post(`${this.api}project-common/${projectId}`, metrics);
  }

  // Work Breakdown Structure (WBS) APIs
  getWBSByProject(projectId: number, bidderView = false): Observable<any> {
    const params = bidderView ? { bidderView: 'true' } : {};
    return this.http.get(`${this.api}work-breakdown-structure/project/${projectId}`, { params });
  }

  /** Orgs that may be assigned to WBS rows (bidding invitees when present, else directory). */
  getWbsAssignableOrganizations(projectId: number): Observable<any> {
    return this.http.get(
      `${this.api}work-breakdown-structure/project/${projectId}/assignable-organizations`
    );
  }

  getWBSById(id: number): Observable<any> {
    return this.http.get(`${this.api}work-breakdown-structure/${id}`);
  }

  createWBSActivity(activity: any): Observable<any> {
    return this.http.post(`${this.api}work-breakdown-structure`, activity);
  }

  updateWBSActivity(id: number, activity: any): Observable<any> {
    return this.http.put(`${this.api}work-breakdown-structure/${id}`, activity);
  }

  deleteWBSActivity(id: number): Observable<any> {
    return this.http.delete(`${this.api}work-breakdown-structure/${id}`);
  }

  bulkUpdateWBS(projectId: number, activities: any[]): Observable<any> {
    return this.http.post(`${this.api}work-breakdown-structure/bulk`, { project_id: projectId, activities });
  }

  importWBSFromExcel(projectId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('project_id', projectId.toString());
    return this.http.post(`${this.api}work-breakdown-structure/import`, formData);
  }

  exportWBSToExcel(projectId: number): Observable<any> {
    return this.http.get(`${this.api}work-breakdown-structure/export/${projectId}`, {
      responseType: 'blob'
    });
  }

  getWBSDeviationReport(params?: {
    project_id?: number;
    start_date?: string;
    end_date?: string;
    group_by?: 'activity' | 'project';
  }): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}work-breakdown-structure/deviation-report`, { params: httpParams });
  }

  // ---------------------------
  // ClickUp Integration (Phase 0/2)
  // ---------------------------
  clickupConnect(body: { project_id?: number; token: string }): Observable<any> {
    return this.http.post(`${this.api}integrations/clickup/connect`, body);
  }

  clickupOAuthMeta(): Observable<any> {
    return this.http.get(`${this.api}integrations/clickup/oauth/meta`);
  }

  clickupOAuthStart(projectId?: number): Observable<any> {
    const params: any = {};
    if (projectId != null) params.project_id = projectId;
    return this.http.get(`${this.api}integrations/clickup/oauth/start`, { params });
  }

  clickupDisconnect(projectId?: number): Observable<any> {
    return this.http.post(`${this.api}integrations/clickup/disconnect`, {
      project_id: projectId ?? undefined,
    });
  }

  clickupStatus(projectId?: number): Observable<any> {
    const params: any = {};
    if (projectId != null) params.project_id = projectId;
    return this.http.get(`${this.api}integrations/clickup/status`, { params });
  }

  clickupUpdateConfig(body: { project_id?: number; config: any }): Observable<any> {
    return this.http.put(`${this.api}integrations/clickup/config`, body);
  }

  clickupLoadList(body: { project_id?: number; url?: string; list_id?: string }): Observable<any> {
    return this.http.post(`${this.api}integrations/clickup/list/load`, body);
  }

  clickupUpdateTaskStatus(body: {
    project_id?: number;
    task_id: string;
    status: string;
  }): Observable<any> {
    return this.http.patch(`${this.api}integrations/clickup/task/status`, body);
  }

  clickupPushProjectWbs(projectId: number): Observable<any> {
    return this.http.post(`${this.api}integrations/clickup/sync/push/project/${projectId}`, {});
  }

  clickupPullTask(projectId: number, taskId: string): Observable<any> {
    return this.http.post(`${this.api}integrations/clickup/sync/pull/project/${projectId}/task/${taskId}`, {});
  }

  clickupPullProjectTasks(projectId: number): Observable<any> {
    return this.http.post(`${this.api}integrations/clickup/sync/pull/project/${projectId}`, {});
  }

  clickupPushProjectWorkOrders(projectId: number): Observable<any> {
    return this.http.post(`${this.api}integrations/clickup/sync/push/work-orders/project/${projectId}`, {});
  }

  clickupRegisterWebhook(body: { project_id?: number; endpoint?: string }): Observable<any> {
    return this.http.post(`${this.api}integrations/clickup/webhook/register`, body);
  }

  clickupUnregisterWebhook(projectId?: number): Observable<any> {
    const params: any = {};
    if (projectId != null) params.project_id = projectId;
    return this.http.delete(`${this.api}integrations/clickup/webhook/register`, { params });
  }

  clickupUpsertUserMap(body: {
    project_id?: number;
    clickup_user_id: string;
    clickup_email?: string;
    sigmat_staff_id?: number;
    sigmat_user_id?: number;
  }): Observable<any> {
    return this.http.post(`${this.api}integrations/clickup/user-map`, body);
  }

  // Document Management APIs
  getDocuments(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}documents`, { params: httpParams });
  }

  getDocumentById(id: number): Observable<any> {
    return this.http.get(`${this.api}documents/${id}`);
  }

  uploadDocument(file: File, data: any): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    if (data.document_name) formData.append('document_name', data.document_name);
    if (data.description) formData.append('description', data.description);
    if (data.category_id) formData.append('category_id', data.category_id);
    if (data.project_id) formData.append('project_id', data.project_id);
    if (data.branch_id) formData.append('branch_id', data.branch_id);
    if (data.tags) formData.append('tags', typeof data.tags === 'string' ? data.tags : JSON.stringify(data.tags));
    if (data.metadata) formData.append('metadata', typeof data.metadata === 'string' ? data.metadata : JSON.stringify(data.metadata));
    if (data.permissions) formData.append('permissions', typeof data.permissions === 'string' ? data.permissions : JSON.stringify(data.permissions));
    
    return this.http.post(`${this.api}documents`, formData);
  }

  updateDocument(id: number, data: any): Observable<any> {
    return this.http.put(`${this.api}documents/${id}`, data, this.httpOptions);
  }

  deleteDocument(id: number): Observable<any> {
    return this.http.delete(`${this.api}documents/${id}`, this.httpOptions);
  }

  restoreDocument(id: number): Observable<any> {
    return this.http.post(`${this.api}documents/${id}/restore`, {}, this.httpOptions);
  }

  downloadDocument(id: number): Observable<Blob> {
    return this.http.get(`${this.api}documents/${id}/download`, {
      responseType: 'blob'
    });
  }

  setDocumentPermissions(id: number, permissions: any[]): Observable<any> {
    return this.http.post(`${this.api}documents/${id}/permissions`, { permissions }, this.httpOptions);
  }

  getDocumentCategories(): Observable<any> {
    return this.http.get(`${this.api}documents/categories`);
  }

  getDocumentTags(params?: { status?: string }): Observable<any> {
    let httpParams = new HttpParams();
    if (params?.status) {
      httpParams = httpParams.set('status', params.status);
    }
    return this.http.get(`${this.api}documents/tags`, { params: httpParams });
  }

  createDocumentCategory(data: any): Observable<any> {
    return this.http.post(`${this.api}documents/categories`, data, this.httpOptions);
  }

  toggleDocumentFavorite(id: number): Observable<any> {
    return this.http.post(`${this.api}documents/${id}/favorite`, {}, this.httpOptions);
  }

  // ============================================
  // Construction Document Management APIs
  // ============================================

  // Get domains and sub-domains for construction documents
  getConstructionDomains(): Observable<any> {
    return this.http.get(`${this.api}construction-documents/domains`, this.httpOptions);
  }

  // Get document requirements (master list)
  getConstructionDocRequirements(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}construction-documents/requirements`, { params: httpParams });
  }

  // Get document requirements for a specific project with tracking status
  getProjectConstructionDocs(projectId: number): Observable<any> {
    return this.http.get(`${this.api}construction-documents/project/${projectId}`, this.httpOptions);
  }

  // Initialize document tracking for a project
  initializeProjectDocs(projectId: number): Observable<any> {
    return this.http.post(`${this.api}construction-documents/project/${projectId}/initialize`, {}, this.httpOptions);
  }

  // Get document summary for a project
  getProjectDocSummary(projectId: number): Observable<any> {
    return this.http.get(`${this.api}construction-documents/project/${projectId}/summary`, this.httpOptions);
  }

  // Update document tracking for a project requirement
  updateProjectDocTracking(projectId: number, requirementId: number, data: any): Observable<any> {
    return this.http.put(`${this.api}construction-documents/project/${projectId}/requirement/${requirementId}`, data, this.httpOptions);
  }

  // Update document tracking by tracking ID
  updateDocTracking(trackingId: number, data: any): Observable<any> {
    return this.http.put(`${this.api}construction-documents/tracking/${trackingId}`, data, this.httpOptions);
  }

  // Get workflow history for a document tracking
  getDocWorkflowHistory(trackingId: number): Observable<any> {
    return this.http.get(`${this.api}construction-documents/tracking/${trackingId}/workflow`, this.httpOptions);
  }

  // Get expiring documents
  getExpiringDocs(days: number = 30): Observable<any> {
    return this.http.get(`${this.api}construction-documents/expiring?days=${days}`, this.httpOptions);
  }

  // Bulk update document status
  bulkUpdateDocStatus(trackingIds: number[], status: string, remarks?: string): Observable<any> {
    return this.http.put(`${this.api}construction-documents/tracking/bulk-update`, {
      tracking_ids: trackingIds,
      status,
      remarks
    }, this.httpOptions);
  }

  // BoQ (Bill of Quantities) APIs
  getBoQs(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}boq`, { params: httpParams });
  }

  getBoQById(id: number): Observable<any> {
    return this.http.get(`${this.api}boq/${id}`);
  }

  createBoQ(data: any): Observable<any> {
    return this.http.post(`${this.api}boq`, data, this.httpOptions);
  }

  updateBoQ(id: number, data: any): Observable<any> {
    return this.http.put(`${this.api}boq/${id}`, data, this.httpOptions);
  }

  deleteBoQ(id: number): Observable<any> {
    return this.http.delete(`${this.api}boq/${id}`, this.httpOptions);
  }

  upsertBoQItem(boqId: number, itemData: any): Observable<any> {
    if (itemData.item_id) {
      return this.http.put(`${this.api}boq/${boqId}/items/${itemData.item_id}`, itemData, this.httpOptions);
    } else {
      return this.http.post(`${this.api}boq/${boqId}/items`, itemData, this.httpOptions);
    }
  }

  deleteBoQItem(boqId: number, itemId: number): Observable<any> {
    return this.http.delete(`${this.api}boq/${boqId}/items/${itemId}`, this.httpOptions);
  }

  recalculateBoQTotals(id: number): Observable<any> {
    return this.http.post(`${this.api}boq/${id}/recalculate`, {}, this.httpOptions);
  }

  assignBoQToManager(boqId: number, staffId: number): Observable<any> {
    return this.http.post(`${this.api}boq/${boqId}/assign`, { assigned_to: staffId }, this.httpOptions);
  }

  getBoQReviewRequests(boqId: number): Observable<any> {
    return this.http.get(`${this.api}boq/${boqId}/review-requests`);
  }

  createBoQReviewRequest(boqId: number, data: { request_type: string; description?: string; payload?: any }): Observable<any> {
    return this.http.post(`${this.api}boq/${boqId}/review-requests`, data, this.httpOptions);
  }

  approveBoQEstimation(boqId: number): Observable<any> {
    return this.http.post(`${this.api}boq/${boqId}/approve-estimation`, {}, this.httpOptions);
  }

  submitBoQForApproval(boqId: number, assignedTo?: number): Observable<any> {
    const body = assignedTo != null ? { assigned_to: assignedTo } : {};
    return this.http.post(`${this.api}boq/${boqId}/submit-for-approval`, body, this.httpOptions);
  }

  rejectBoQEstimation(boqId: number, reason: string): Observable<any> {
    return this.http.post(`${this.api}boq/${boqId}/reject-estimation`, { reason }, this.httpOptions);
  }

  getBoQFees(boqId: number): Observable<any> {
    return this.http.get(`${this.api}boq/${boqId}/fees`, this.httpOptions);
  }

  getBoQPlannedActualDeviation(boqId: number): Observable<any> {
    return this.http.get(`${this.api}boq/${boqId}/planned-actual-deviation`, this.httpOptions);
  }

  calculateSubscriptionFee(data: any): Observable<any> {
    return this.http.post(`${this.api}subscription/calculate`, data, this.httpOptions);
  }

  // BOQ Bidding Invitation APIs
  getConsultancyOrganizations(): Observable<any> {
    return this.http.get(`${this.api}boq-bidding-invitation/consultancy-organizations`);
  }

  createBiddingInvitation(data: { boq_id: number; project_id: number; invited_org_ids: number[]; invited_emails?: string[]; bid_closing_at?: string; requirements?: string }): Observable<any> {
    return this.http.post(`${this.api}boq-bidding-invitation/invitation`, data, this.httpOptions);
  }

  addBiddingInvitees(invitationId: number, data: { invited_org_ids?: number[]; invited_emails?: string[] }): Observable<any> {
    return this.http.post(`${this.api}boq-bidding-invitation/invitation/${invitationId}/add-invitees`, data, this.httpOptions);
  }

  getBiddingInvitationByToken(token: string): Observable<any> {
    return this.http.get(`${this.api}boq-bidding-invitation/invite/${token}`);
  }

  getBidderView(token: string): Observable<any> {
    return this.http.get(`${this.api}boq-bidding-invitation/invite/${token}/bidder-view`, this.httpOptions);
  }

  getBiddingQueries(token: string): Observable<any> {
    return this.http.get(`${this.api}boq-bidding-invitation/invite/${token}/queries`, this.httpOptions);
  }

  createBiddingQuery(token: string, queryText: string): Observable<any> {
    return this.http.post(`${this.api}boq-bidding-invitation/invite/${token}/queries`, { query_text: queryText }, this.httpOptions);
  }

  replyToBiddingQuery(invitationId: number, queryId: number, replyText: string): Observable<any> {
    return this.http.post(
      `${this.api}boq-bidding-invitation/invitation/${invitationId}/queries/${queryId}/reply`,
      { reply_text: replyText },
      this.httpOptions
    );
  }

  submitBiddingResponse(token: string, data: { bid_amount?: number; bid_data?: any; remarks?: string }): Observable<any> {
    return this.http.post(`${this.api}boq-bidding-invitation/invite/${token}/submit`, data, this.httpOptions);
  }

  submitBiddingResponseGuest(token: string, data: { email: string; contact_name?: string; bid_amount?: number; bid_data?: any; remarks?: string }): Observable<any> {
    return this.http.post(`${this.api}boq-bidding-invitation/invite/${token}/submit-guest`, data, this.httpOptions);
  }

  getGuestBid(token: string, email: string): Observable<any> {
    return this.http.get(`${this.api}boq-bidding-invitation/invite/${token}/guest-bid`, { params: { email } });
  }

  getBiddingInvitationsByBoq(boqId: number): Observable<any> {
    return this.http.get(`${this.api}boq-bidding-invitation/invitation/boq/${boqId}`);
  }

  getBiddingResponsesByInvitation(invitationId: number): Observable<any> {
    return this.http.get(`${this.api}boq-bidding-invitation/invitation/${invitationId}/responses`, this.httpOptions);
  }

  getBiddingDeviationReport(invitationId: number): Observable<any> {
    return this.http.get(`${this.api}boq-bidding-invitation/invitation/${invitationId}/deviation-report`, this.httpOptions);
  }

  updateBidStatus(invitationId: number, responseId: number, status: 'shortlisted' | 'rejected'): Observable<any> {
    return this.http.patch(
      `${this.api}boq-bidding-invitation/invitation/${invitationId}/responses/${responseId}/status`,
      { status },
      this.httpOptions
    );
  }

  createBiddingAward(invitationId: number, responseIds: number[]): Observable<any> {
    return this.http.post(
      `${this.api}boq-bidding-invitation/invitation/${invitationId}/award`,
      { response_ids: responseIds },
      this.httpOptions
    );
  }

  getBiddingAwardsByInvitation(invitationId: number): Observable<any> {
    return this.http.get(`${this.api}boq-bidding-invitation/invitation/${invitationId}/awards`, this.httpOptions);
  }

  sendBidReminder(invitationId: number): Observable<any> {
    return this.http.post(
      `${this.api}boq-bidding-invitation/invitation/${invitationId}/send-bid-reminder`,
      {},
      this.httpOptions
    );
  }

  extendBidClosing(invitationId: number, body: { new_bid_closing_at: string; message?: string }): Observable<any> {
    return this.http.post(
      `${this.api}boq-bidding-invitation/invitation/${invitationId}/extend-closing`,
      body,
      this.httpOptions
    );
  }

  closeBidByPlanner(invitationId: number, body: { comments?: string }): Observable<any> {
    return this.http.post(
      `${this.api}boq-bidding-invitation/invitation/${invitationId}/close-bid`,
      body,
      this.httpOptions
    );
  }

  getProjectsAwardedToMe(): Observable<any> {
    return this.http.get(`${this.api}boq-bidding-invitation/awarded-projects`, this.httpOptions);
  }

  // BoQ Units Master APIs
  getBoQUnits(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}boq-units`, { params: httpParams });
  }

  getBoQUnitById(id: number): Observable<any> {
    return this.http.get(`${this.api}boq-units/${id}`);
  }

  getBoQUnitByCode(code: string): Observable<any> {
    return this.http.get(`${this.api}boq-units/code/${code}`);
  }

  getBoQUnitsByType(): Observable<any> {
    return this.http.get(`${this.api}boq-units/by-type`);
  }

  createBoQUnit(data: any): Observable<any> {
    return this.http.post(`${this.api}boq-units`, data, this.httpOptions);
  }

  updateBoQUnit(id: number, data: any): Observable<any> {
    return this.http.put(`${this.api}boq-units/${id}`, data, this.httpOptions);
  }

  deleteBoQUnit(id: number): Observable<any> {
    return this.http.delete(`${this.api}boq-units/${id}`, this.httpOptions);
  }

  // Project Bills APIs
  getProjectBills(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}project-bills`, { params: httpParams });
  }

  getProjectBillById(id: number): Observable<any> {
    return this.http.get(`${this.api}project-bills/${id}`);
  }

  updateProjectBill(id: number, data: any): Observable<any> {
    return this.http.put(`${this.api}project-bills/${id}`, data, this.httpOptions);
  }

  getProjectBillsSummary(): Observable<any> {
    return this.http.get(`${this.api}project-bills/summary`);
  }

  // Project Bill Payment Methods
  createBillPaymentOrder(billId: number): Observable<any> {
    return this.http.post(`${this.api}project-bills/${billId}/create-payment-order`, {}, this.httpOptions);
  }

  verifyBillPayment(billId: number, paymentData: any): Observable<any> {
    return this.http.post(`${this.api}project-bills/${billId}/verify-payment`, paymentData, this.httpOptions);
  }

  // Super Admin Subscription Management APIs
  getSuperAdminSubscriptions(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}admin/subscriptions`, { params: httpParams });
  }

  getSuperAdminSubscriptionById(id: number): Observable<any> {
    return this.http.get(`${this.api}admin/subscriptions/${id}`);
  }

  updateSubscriptionDuration(id: number, data: any): Observable<any> {
    return this.http.put(`${this.api}admin/subscriptions/${id}/duration`, data, this.httpOptions);
  }

  updateSubscriptionDates(id: number, data: any): Observable<any> {
    return this.http.put(`${this.api}admin/subscriptions/${id}/dates`, data, this.httpOptions);
  }

  createSubscriptionRefund(subscriptionId: number, data: any): Observable<any> {
    return this.http.post(`${this.api}admin/subscriptions/${subscriptionId}/refunds`, data, this.httpOptions);
  }

  processRefund(refundId: number, data: any): Observable<any> {
    return this.http.put(`${this.api}admin/subscriptions/refunds/${refundId}/process`, data, this.httpOptions);
  }

  getAllRefunds(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}admin/subscriptions/refunds/all`, { params: httpParams });
  }

  getSubscriptionStatistics(): Observable<any> {
    return this.http.get(`${this.api}admin/subscriptions/statistics`);
  }

  // Road BoQ APIs
  getRoadBoQs(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}road-boq`, { params: httpParams });
  }

  getRoadBoQById(id: number): Observable<any> {
    return this.http.get(`${this.api}road-boq/${id}`);
  }

  createRoadBoQ(data: any): Observable<any> {
    return this.http.post(`${this.api}road-boq`, data, this.httpOptions);
  }

  updateRoadBoQ(id: number, data: any): Observable<any> {
    return this.http.put(`${this.api}road-boq/${id}`, data, this.httpOptions);
  }

  deleteRoadBoQ(id: number): Observable<any> {
    return this.http.delete(`${this.api}road-boq/${id}`, this.httpOptions);
  }

  // Road BoQ Sections
  addRoadBoQSection(roadBoqId: number, data: any): Observable<any> {
    return this.http.post(`${this.api}road-boq/${roadBoqId}/sections`, data, this.httpOptions);
  }

  updateRoadBoQSection(roadBoqId: number, sectionId: number, data: any): Observable<any> {
    return this.http.put(`${this.api}road-boq/${roadBoqId}/sections/${sectionId}`, data, this.httpOptions);
  }

  deleteRoadBoQSection(roadBoqId: number, sectionId: number): Observable<any> {
    return this.http.delete(`${this.api}road-boq/${roadBoqId}/sections/${sectionId}`, this.httpOptions);
  }

  // Road BoQ Items
  addRoadBoQItem(roadBoqId: number, data: any): Observable<any> {
    return this.http.post(`${this.api}road-boq/${roadBoqId}/items`, data, this.httpOptions);
  }

  updateRoadBoQItem(roadBoqId: number, itemId: number, data: any): Observable<any> {
    return this.http.put(`${this.api}road-boq/${roadBoqId}/items/${itemId}`, data, this.httpOptions);
  }

  deleteRoadBoQItem(roadBoqId: number, itemId: number): Observable<any> {
    return this.http.delete(`${this.api}road-boq/${roadBoqId}/items/${itemId}`, this.httpOptions);
  }

  // Road BOM
  addRoadBOMItem(roadBoqId: number, data: any): Observable<any> {
    return this.http.post(`${this.api}road-boq/${roadBoqId}/bom`, data, this.httpOptions);
  }

  updateRoadBOMItem(roadBoqId: number, bomId: number, data: any): Observable<any> {
    return this.http.put(`${this.api}road-boq/${roadBoqId}/bom/${bomId}`, data, this.httpOptions);
  }

  deleteRoadBOMItem(roadBoqId: number, bomId: number): Observable<any> {
    return this.http.delete(`${this.api}road-boq/${roadBoqId}/bom/${bomId}`, this.httpOptions);
  }

  // Road BoQ Templates
  getRoadBoQTemplates(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}road-boq/templates`, { params: httpParams });
  }

  createRoadBoQFromTemplate(templateId: number, data: any): Observable<any> {
    return this.http.post(`${this.api}road-boq/templates/${templateId}/create`, data, this.httpOptions);
  }

  // Work Order APIs
  getWorkOrders(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}work-orders`, { params: httpParams });
  }

  getWorkOrderById(id: number): Observable<any> {
    return this.http.get(`${this.api}work-orders/${id}`);
  }

  getWorkOrderByToken(token: string): Observable<any> {
    return this.http.get(`${this.api}work-orders/public/${token}`);
  }

  createWorkOrder(data: any): Observable<any> {
    return this.http.post(`${this.api}work-orders`, data, this.httpOptions);
  }

  updateWorkOrder(id: number, data: any): Observable<any> {
    return this.http.put(`${this.api}work-orders/${id}`, data, this.httpOptions);
  }

  deleteWorkOrder(id: number): Observable<any> {
    return this.http.delete(`${this.api}work-orders/${id}`, this.httpOptions);
  }

  shareWorkOrderWithClient(id: number): Observable<any> {
    return this.http.post(`${this.api}work-orders/${id}/share`, {}, this.httpOptions);
  }

  generateWorkOrderPDF(id: number): Observable<any> {
    return this.http.get(`${this.api}work-orders/${id}/pdf`);
  }

  sendWorkOrderEmail(id: number, data: any): Observable<any> {
    return this.http.post(`${this.api}work-orders/${id}/email`, data, this.httpOptions);
  }

  getProjectDataForWorkOrder(params: any): Observable<any> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      const value = (params as any)[key];
      if (value !== null && value !== undefined) {
        httpParams = httpParams.set(key, value.toString());
      }
    });
    return this.http.get(`${this.api}work-orders/project-data`, { params: httpParams });
  }

  // Unit Conversion APIs
  convertUnit(data: any): Observable<any> {
    return this.http.post(`${this.api}unit-conversion/convert`, data, this.httpOptions);
  }

  convertProjectField(data: any): Observable<any> {
    return this.http.post(`${this.api}unit-conversion/convert-project-field`, data, this.httpOptions);
  }

  standardizeProjectField(data: any): Observable<any> {
    return this.http.post(`${this.api}unit-conversion/standardize`, data, this.httpOptions);
  }

  getAvailableUnitsForFieldType(fieldType: string): Observable<any> {
    return this.http.get(`${this.api}unit-conversion/available-units/${fieldType}`, this.httpOptions);
  }

  batchConvertUnits(conversions: any[]): Observable<any> {
    return this.http.post(`${this.api}unit-conversion/batch-convert`, { conversions }, this.httpOptions);
  }

  // Alert APIs
  getAlerts(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}alerts`, { params: httpParams });
  }

  getAlertById(id: number): Observable<any> {
    return this.http.get(`${this.api}alerts/${id}`, this.httpOptions);
  }

  acknowledgeAlert(id: number): Observable<any> {
    return this.http.post(`${this.api}alerts/${id}/acknowledge`, {}, this.httpOptions);
  }

  dismissAlert(id: number): Observable<any> {
    return this.http.post(`${this.api}alerts/${id}/dismiss`, {}, this.httpOptions);
  }

  // Subscription Access APIs
  getSubscriptionModules(): Observable<any> {
    return this.http.get(`${this.api}subscription-access/modules`, this.httpOptions);
  }

  getOrganizationsForSwitch(): Observable<any> {
    return this.http.get(`${this.api}subscription-access/organizations`, this.httpOptions);
  }

  // Staff Identity Document APIs
  getIdentityDocumentRequirements(): Observable<any> {
    return this.http.get(`${this.api}staff-identity-documents/requirements`, this.httpOptions);
  }

  getStaffIdentityDocuments(staffId?: number): Observable<any> {
    if (staffId) {
      return this.http.get(`${this.api}staff-identity-documents/staff/${staffId}`, this.httpOptions);
    }
    return this.http.get(`${this.api}staff-identity-documents/my-documents`, this.httpOptions);
  }

  getIdentityDocumentStatus(staffId?: number): Observable<any> {
    if (staffId) {
      return this.http.get(`${this.api}staff-identity-documents/status/${staffId}`, this.httpOptions);
    }
    return this.http.get(`${this.api}staff-identity-documents/my-status`, this.httpOptions);
  }

  checkDocumentUploadRequired(): Observable<any> {
    return this.http.get(`${this.api}staff-identity-documents/check-required`, this.httpOptions);
  }

  uploadIdentityDocument(file: File, data: any): Observable<any> {
    const formData = new FormData();
    formData.append('document', file);
    if (data.document_type) formData.append('document_type', data.document_type);
    if (data.document_name) formData.append('document_name', data.document_name);
    if (data.document_number) formData.append('document_number', data.document_number);
    if (data.expiry_date) formData.append('expiry_date', data.expiry_date);
    if (data.staff_id) formData.append('staff_id', data.staff_id.toString());
    return this.http.post(`${this.api}staff-identity-documents/upload`, formData);
  }

  verifyIdentityDocument(id: number, data: any): Observable<any> {
    return this.http.put(`${this.api}staff-identity-documents/verify/${id}`, data, this.httpOptions);
  }

  deleteIdentityDocument(id: number): Observable<any> {
    return this.http.delete(`${this.api}staff-identity-documents/${id}`, this.httpOptions);
  }

  getPendingDocumentVerifications(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get(`${this.api}staff-identity-documents/pending-verifications`, { params: httpParams });
  }

  completeFirstLogin(): Observable<any> {
    return this.http.post(`${this.api}staff-identity-documents/complete-first-login`, {}, this.httpOptions);
  }

}
